module.exports = __webpack_public_path__ + "img/Leonidas_Esteban.db6cd946.jpg";